export const translations = {
  en: {
    // Home page
    yourPugliaconcierge: "YOUR PUGLIA CONCIERGE",
    welcomeTo: "Welcome to",
    planMyStay: "Plan my stay with Lina",
    orTryAsking: "Or try asking...",
    yourStayPlanned: "Your stay, planned for today",
    personalizedFor: "Personalised suggestions for",
    quickActions: "Quick actions",
    enhanceYourStay: "Enhance your stay",
    makeEffortless: "Make your Puglia experience effortless",
    viewAll: "View all",
    exploreOspitai: "Explore OspitAI",
    everythingYouNeed: "Everything you need for your Puglia stay",
    needHelpNow: "Need help right now?",
    reachHost: "Reach your host directly for urgent matters or property support",
    messageWhatsapp: "Message on WhatsApp",
    callProperty: "Call property",
    emergency: "Emergency",
    arrive: "Arrive",
    depart: "Depart",
    checkIn: "Check-in",
    checkOut: "Check-out",
    select: "Select",

    // Navigation
    home: "Home",
    concierge: "Concierge",
    beaches: "Beaches",
    parking: "Parking",
    events: "Events",
    upsells: "Upsells",
    restaurants: "Restaurants",
    hostLogin: "Host Login",

    // Beaches page
    beachesTitle: "Beaches & Lidos in Puglia",
    verifiedBeaches: "verified beaches from Monopoli to Salento",
    allBeaches: "All beaches",
    quietSpots: "Quiet spots",
    beachClubs: "Beach clubs",
    freeBeaches: "Free beaches",
    allTowns: "All towns",
    allTypes: "All types",
    sandy: "Sandy",
    rocky: "Rocky",
    pebble: "Pebble",
    mixed: "Mixed",
    beachesFound: "beaches found",
    beachFound: "beach found",
    localTip: "Local tip",
    amenities: "Amenities",
    reserveSunbeds: "Reserve sunbeds",
    perDay: "per day",
    visitWebsite: "Visit website",
    notSureWhichBeach: "Not sure which beach?",
    askLinaBeach: "Ask Lina for a personalised recommendation based on your preferences",
    askLina: "Ask Lina",
    viewOnMap: "View on map",
    showMap: "Show map",
    hideMap: "Hide map",
    kmFromMonopoli: "km from Monopoli",
    quiet: "Quiet",
    moderate: "Moderate",
    popular: "Popular",
    veryBusy: "Very busy",
    hiddenGem: "Hidden gem",
    familyFriendly: "Family friendly",

    // Parking page
    parkingGuide: "Parking Guide",
    parkingSpotsAcross: "parking spots across Monopoli, Polignano, Ostuni & Bari",
    all: "All",
    free: "Free",
    paid: "Paid",
    walkToCentro: "walk to centro",

    // Restaurants page
    whereToEat: "Where to Eat",
    verifiedRestaurants: "Verified trattorias, ristoranti and fine dining in Puglia",
    allPrices: "All prices",
    budget: "Budget",
    mid: "Mid",
    fine: "Fine",
    luxury: "Luxury",
    romantic: "Romantic",
    outdoorSeating: "Outdoor seating",
    bookTable: "Book a table",
    callToReserve: "Call to reserve",
    perPerson: "per person",

    // Events page
    whatsOn: "What's On in Puglia",
    verifiedEvents: "Verified events, festivals and experiences nearby",
    allEvents: "All Events",
    festivals: "Festivals",
    music: "Music",
    foodWine: "Food & Wine",
    culture: "Culture",
    markets: "Markets",
    experiences: "Experiences",
    freeEventsOnly: "Free events only",
    noEventsFound: "No events found matching your filters.",
    inMonopoli: "In Monopoli",
    kmAway: "km away",
    verifiedSource: "Verified source",

    // Upsells page
    enhanceYourStayTitle: "Enhance Your Stay",
    transfersBeachExperiences: "Transfers, beach clubs, experiences and late checkout",
    transfers: "Transfers",
    beach: "Beach",
    stay: "Stay",
    bookNow: "Book now",
    requestBooking: "Request Booking",
    bookingRequested: "Booking Requested!",
    bookingReference: "Your booking reference is",
    confirmationSoon: "We'll confirm your reservation shortly via email. Our host will reach out if they need any additional details.",
    done: "Done",
    yourName: "Your Name",
    email: "Email",
    phone: "Phone",
    optional: "optional",
    preferredDate: "Preferred Date",
    time: "Time",
    numberOfGuests: "Number of Guests",
    guest: "guest",
    guests: "guests",
    specialRequests: "Special Requests",
    anySpecialRequirements: "Any special requirements or questions...",
    submitting: "Submitting...",
    confirmAvailability: "We'll confirm availability and send you confirmation details via email.",

    // Emergency page
    emergencySupport: "Emergency & Support",
    fastAccess: "Fast access to emergency numbers, property support and urgent help",
    propertySupport: "Property Support",
    keyIssues: "For key issues, late arrival, house access or urgent property matters at",
    otherUsefulNumbers: "Other useful numbers",
    goodToKnow: "Good to know",
    emergency112: "112 works from any phone, even without a SIM card",
    pharmacyTip: "Pharmacies display a green cross and rotate night duty — look for \"farmacia di turno\"",
    guardiaMedica: "For non-emergencies, Guardia Medica provides out-of-hours medical care",
    keepAddress: "Keep your property address handy — emergency services may need the exact location",
    call: "Call",

    // Concierge page
    yourPugliaConcierge: "Your Puglia Concierge",
    askAbout: "Ask me about beaches, restaurants, transfers, events, or let me plan your perfect day in Puglia.",
    popularRequests: "Popular requests",
    whatShouldWeDo: "What should we do today?",
    askLinaAnything: "Ask Lina anything...",
    needAirportTransfer: "Need an airport transfer?",
    privateCarFromBari: "Private car from Bari",

    // Host pages
    hostDashboard: "Host Dashboard",
    signIn: "Sign in",
    createAccount: "Create account",
    accessDashboard: "Access your OspitAI dashboard",
    registerProperty: "Register your property with OspitAI",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    register: "Register",
    password: "Password",
    propertyName: "Property Name",
    location: "Location",
    pleaseWait: "Please wait...",
    bySigningIn: "By signing in, you agree to our",
    terms: "Terms",
    and: "and",
    privacyPolicy: "Privacy Policy",

    // Footer
    allRightsReserved: "All rights reserved",
    termsConditions: "Terms & Conditions",
    unauthorizedUse: "Unauthorized reproduction or use of this platform is prohibited.",

    // Common
    loading: "Loading...",
    error: "Error",
    tryAgain: "Try again",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    from: "from",

    // Cultural guidance
    culturalTips: "Cultural Tips",
    localEtiquette: "Local Etiquette",
    dressCode: "Dress Code",
    tippingGuide: "Tipping Guide",
    culturalGuidance: "Cultural Guidance",
    pugliaCultureTitle: "Puglia Culture & Customs",
    pugliaCultureDesc: "Essential tips for respecting local traditions",
    
    // Etiquette tips
    greetingsTip: "Greetings: Italians often greet with a kiss on both cheeks. Start from the left.",
    diningTip: "Dining: Lunch is sacred (1-3pm). Many shops close. Dinner starts after 8pm.",
    churchTip: "Churches: Cover shoulders and knees when visiting religious sites.",
    siestaTip: "Siesta: Respect the riposo (rest) from 1-4pm. Many businesses close.",
    
    // Dress code tips
    beachDressCode: "Beach attire is for the beach only. Cover up when visiting towns.",
    restaurantDressCode: "Smart casual for restaurants. No shorts at upscale venues.",
    eveningDressCode: "Pugliese dress elegantly for the evening passeggiata (stroll).",
    
    // Tipping tips
    tippingRestaurants: "Restaurants: Service charge (coperto) is usually included. Round up if satisfied.",
    tippingBars: "Bars: Tipping is not expected but €0.50-1 for table service is appreciated.",
    tippingTours: "Tours: €5-10 per person for excellent guides.",
    tippingTaxi: "Taxi: Round up to the nearest euro.",
  },

  it: {
    // Home page
    yourPugliaconcierge: "IL TUO CONCIERGE IN PUGLIA",
    welcomeTo: "Benvenuto a",
    planMyStay: "Pianifica il soggiorno con Lina",
    orTryAsking: "Oppure prova a chiedere...",
    yourStayPlanned: "Il tuo soggiorno, pianificato per oggi",
    personalizedFor: "Suggerimenti personalizzati per",
    quickActions: "Azioni rapide",
    enhanceYourStay: "Migliora il tuo soggiorno",
    makeEffortless: "Rendi la tua esperienza in Puglia senza sforzo",
    viewAll: "Vedi tutto",
    exploreOspitai: "Esplora OspitAI",
    everythingYouNeed: "Tutto ciò di cui hai bisogno per il tuo soggiorno",
    needHelpNow: "Hai bisogno di aiuto adesso?",
    reachHost: "Contatta il tuo host per questioni urgenti",
    messageWhatsapp: "Messaggio su WhatsApp",
    callProperty: "Chiama la proprietà",
    emergency: "Emergenza",
    arrive: "Arrivo",
    depart: "Partenza",
    checkIn: "Check-in",
    checkOut: "Check-out",
    select: "Seleziona",

    // Navigation
    home: "Home",
    concierge: "Concierge",
    beaches: "Spiagge",
    parking: "Parcheggio",
    events: "Eventi",
    upsells: "Extra",
    restaurants: "Ristoranti",
    hostLogin: "Accesso Host",

    // Beaches page
    beachesTitle: "Spiagge e Lidi in Puglia",
    verifiedBeaches: "spiagge verificate da Monopoli al Salento",
    allBeaches: "Tutte le spiagge",
    quietSpots: "Zone tranquille",
    beachClubs: "Stabilimenti",
    freeBeaches: "Spiagge libere",
    allTowns: "Tutte le città",
    allTypes: "Tutti i tipi",
    sandy: "Sabbiosa",
    rocky: "Rocciosa",
    pebble: "Ciottoli",
    mixed: "Mista",
    beachesFound: "spiagge trovate",
    beachFound: "spiaggia trovata",
    localTip: "Consiglio locale",
    amenities: "Servizi",
    reserveSunbeds: "Prenota lettini",
    perDay: "al giorno",
    visitWebsite: "Visita il sito",
    notSureWhichBeach: "Non sai quale spiaggia scegliere?",
    askLinaBeach: "Chiedi a Lina un consiglio personalizzato in base alle tue preferenze",
    askLina: "Chiedi a Lina",
    viewOnMap: "Vedi sulla mappa",
    showMap: "Mostra mappa",
    hideMap: "Nascondi mappa",
    kmFromMonopoli: "km da Monopoli",
    quiet: "Tranquilla",
    moderate: "Moderata",
    popular: "Popolare",
    veryBusy: "Molto affollata",
    hiddenGem: "Perla nascosta",
    familyFriendly: "Adatta alle famiglie",

    // Parking page
    parkingGuide: "Guida Parcheggi",
    parkingSpotsAcross: "parcheggi a Monopoli, Polignano, Ostuni e Bari",
    all: "Tutti",
    free: "Gratuiti",
    paid: "A pagamento",
    walkToCentro: "a piedi dal centro",

    // Restaurants page
    whereToEat: "Dove Mangiare",
    verifiedRestaurants: "Trattorie, ristoranti e alta cucina verificati in Puglia",
    allPrices: "Tutti i prezzi",
    budget: "Economico",
    mid: "Medio",
    fine: "Raffinato",
    luxury: "Lusso",
    romantic: "Romantico",
    outdoorSeating: "Tavoli all'aperto",
    bookTable: "Prenota un tavolo",
    callToReserve: "Chiama per prenotare",
    perPerson: "a persona",

    // Events page
    whatsOn: "Eventi in Puglia",
    verifiedEvents: "Eventi, festival ed esperienze verificate nelle vicinanze",
    allEvents: "Tutti gli Eventi",
    festivals: "Festival",
    music: "Musica",
    foodWine: "Cibo e Vino",
    culture: "Cultura",
    markets: "Mercati",
    experiences: "Esperienze",
    freeEventsOnly: "Solo eventi gratuiti",
    noEventsFound: "Nessun evento trovato con i filtri selezionati.",
    inMonopoli: "A Monopoli",
    kmAway: "km di distanza",
    verifiedSource: "Fonte verificata",

    // Upsells page
    enhanceYourStayTitle: "Migliora il Tuo Soggiorno",
    transfersBeachExperiences: "Transfer, stabilimenti, esperienze e late checkout",
    transfers: "Transfer",
    beach: "Spiaggia",
    stay: "Soggiorno",
    bookNow: "Prenota ora",
    requestBooking: "Richiedi Prenotazione",
    bookingRequested: "Prenotazione Richiesta!",
    bookingReference: "Il tuo riferimento è",
    confirmationSoon: "Confermeremo la tua prenotazione via email. Il nostro host ti contatterà se avrà bisogno di ulteriori dettagli.",
    done: "Fatto",
    yourName: "Il Tuo Nome",
    email: "Email",
    phone: "Telefono",
    optional: "opzionale",
    preferredDate: "Data Preferita",
    time: "Ora",
    numberOfGuests: "Numero di Ospiti",
    guest: "ospite",
    guests: "ospiti",
    specialRequests: "Richieste Speciali",
    anySpecialRequirements: "Eventuali requisiti speciali o domande...",
    submitting: "Invio in corso...",
    confirmAvailability: "Confermeremo la disponibilità e ti invieremo i dettagli via email.",

    // Emergency page
    emergencySupport: "Emergenza e Supporto",
    fastAccess: "Accesso rapido ai numeri di emergenza, supporto proprietà e aiuto urgente",
    propertySupport: "Supporto Proprietà",
    keyIssues: "Per problemi con le chiavi, arrivo in ritardo, accesso alla casa o questioni urgenti presso",
    otherUsefulNumbers: "Altri numeri utili",
    goodToKnow: "Buono a sapersi",
    emergency112: "Il 112 funziona da qualsiasi telefono, anche senza SIM",
    pharmacyTip: "Le farmacie mostrano una croce verde e fanno turni notturni — cerca \"farmacia di turno\"",
    guardiaMedica: "Per non-emergenze, la Guardia Medica fornisce assistenza medica fuori orario",
    keepAddress: "Tieni a portata di mano l'indirizzo della proprietà — i servizi di emergenza potrebbero aver bisogno della posizione esatta",
    call: "Chiama",

    // Concierge page
    yourPugliaConcierge: "Il Tuo Concierge in Puglia",
    askAbout: "Chiedimi di spiagge, ristoranti, transfer, eventi, o lasciami pianificare la tua giornata perfetta in Puglia.",
    popularRequests: "Richieste popolari",
    whatShouldWeDo: "Cosa facciamo oggi?",
    askLinaAnything: "Chiedi qualsiasi cosa a Lina...",
    needAirportTransfer: "Hai bisogno di un transfer dall'aeroporto?",
    privateCarFromBari: "Auto privata da Bari",

    // Host pages
    hostDashboard: "Dashboard Host",
    signIn: "Accedi",
    createAccount: "Crea account",
    accessDashboard: "Accedi alla tua dashboard OspitAI",
    registerProperty: "Registra la tua proprietà con OspitAI",
    dontHaveAccount: "Non hai un account?",
    alreadyHaveAccount: "Hai già un account?",
    register: "Registrati",
    password: "Password",
    propertyName: "Nome Proprietà",
    location: "Località",
    pleaseWait: "Attendere...",
    bySigningIn: "Accedendo, accetti i nostri",
    terms: "Termini",
    and: "e",
    privacyPolicy: "Privacy Policy",

    // Footer
    allRightsReserved: "Tutti i diritti riservati",
    termsConditions: "Termini e Condizioni",
    unauthorizedUse: "È vietata la riproduzione o l'uso non autorizzato di questa piattaforma.",

    // Common
    loading: "Caricamento...",
    error: "Errore",
    tryAgain: "Riprova",
    close: "Chiudi",
    save: "Salva",
    cancel: "Annulla",
    confirm: "Conferma",
    back: "Indietro",
    next: "Avanti",
    from: "da",

    // Cultural guidance
    culturalTips: "Consigli Culturali",
    localEtiquette: "Etichetta Locale",
    dressCode: "Codice di Abbigliamento",
    tippingGuide: "Guida alle Mance",
    culturalGuidance: "Guida Culturale",
    pugliaCultureTitle: "Cultura e Tradizioni Pugliesi",
    pugliaCultureDesc: "Consigli essenziali per rispettare le tradizioni locali",
    
    // Etiquette tips
    greetingsTip: "Saluti: Gli italiani spesso salutano con un bacio su entrambe le guance. Inizia da sinistra.",
    diningTip: "Pranzo: Il pranzo è sacro (13-15). Molti negozi chiudono. La cena inizia dopo le 20.",
    churchTip: "Chiese: Copri spalle e ginocchia quando visiti luoghi religiosi.",
    siestaTip: "Riposo: Rispetta il riposo dalle 13 alle 16. Molte attività chiudono.",
    
    // Dress code tips
    beachDressCode: "L'abbigliamento da spiaggia è solo per la spiaggia. Copriti quando visiti i paesi.",
    restaurantDressCode: "Smart casual per i ristoranti. Niente shorts nei locali eleganti.",
    eveningDressCode: "I pugliesi si vestono eleganti per la passeggiata serale.",
    
    // Tipping tips
    tippingRestaurants: "Ristoranti: Il servizio (coperto) è solitamente incluso. Arrotonda se soddisfatto.",
    tippingBars: "Bar: La mancia non è prevista ma €0,50-1 per il servizio al tavolo è apprezzato.",
    tippingTours: "Tour: €5-10 a persona per guide eccellenti.",
    tippingTaxi: "Taxi: Arrotonda all'euro più vicino.",
  },

  fr: {
    // Home page
    yourPugliaconcierge: "VOTRE CONCIERGE DES POUILLES",
    welcomeTo: "Bienvenue à",
    planMyStay: "Planifier mon séjour avec Lina",
    orTryAsking: "Ou essayez de demander...",
    yourStayPlanned: "Votre séjour, planifié pour aujourd'hui",
    personalizedFor: "Suggestions personnalisées pour",
    quickActions: "Actions rapides",
    enhanceYourStay: "Améliorez votre séjour",
    makeEffortless: "Rendez votre expérience en Pouilles sans effort",
    viewAll: "Voir tout",
    exploreOspitai: "Explorer OspitAI",
    everythingYouNeed: "Tout ce dont vous avez besoin pour votre séjour",
    needHelpNow: "Besoin d'aide maintenant?",
    reachHost: "Contactez votre hôte pour les questions urgentes",
    messageWhatsapp: "Message sur WhatsApp",
    callProperty: "Appeler la propriété",
    emergency: "Urgence",
    arrive: "Arrivée",
    depart: "Départ",
    checkIn: "Arrivée",
    checkOut: "Départ",
    select: "Sélectionner",

    // Navigation
    home: "Accueil",
    concierge: "Concierge",
    beaches: "Plages",
    parking: "Parking",
    events: "Événements",
    upsells: "Extras",
    restaurants: "Restaurants",
    hostLogin: "Connexion Hôte",

    // Beaches page
    beachesTitle: "Plages et Lidos des Pouilles",
    verifiedBeaches: "plages vérifiées de Monopoli au Salento",
    allBeaches: "Toutes les plages",
    quietSpots: "Coins tranquilles",
    beachClubs: "Clubs de plage",
    freeBeaches: "Plages gratuites",
    allTowns: "Toutes les villes",
    allTypes: "Tous les types",
    sandy: "Sableuse",
    rocky: "Rocheuse",
    pebble: "Galets",
    mixed: "Mixte",
    beachesFound: "plages trouvées",
    beachFound: "plage trouvée",
    localTip: "Conseil local",
    amenities: "Équipements",
    reserveSunbeds: "Réserver des transats",
    perDay: "par jour",
    visitWebsite: "Visiter le site",
    notSureWhichBeach: "Vous ne savez pas quelle plage choisir?",
    askLinaBeach: "Demandez à Lina une recommandation personnalisée selon vos préférences",
    askLina: "Demander à Lina",
    viewOnMap: "Voir sur la carte",
    showMap: "Afficher la carte",
    hideMap: "Masquer la carte",
    kmFromMonopoli: "km de Monopoli",
    quiet: "Calme",
    moderate: "Modérée",
    popular: "Populaire",
    veryBusy: "Très fréquentée",
    hiddenGem: "Perle cachée",
    familyFriendly: "Familiale",

    // Parking page
    parkingGuide: "Guide du Parking",
    parkingSpotsAcross: "places de parking à Monopoli, Polignano, Ostuni et Bari",
    all: "Tous",
    free: "Gratuits",
    paid: "Payants",
    walkToCentro: "à pied du centre",

    // Restaurants page
    whereToEat: "Où Manger",
    verifiedRestaurants: "Trattorias, restaurants et gastronomie vérifiés dans les Pouilles",
    allPrices: "Tous les prix",
    budget: "Économique",
    mid: "Moyen",
    fine: "Raffiné",
    luxury: "Luxe",
    romantic: "Romantique",
    outdoorSeating: "Terrasse",
    bookTable: "Réserver une table",
    callToReserve: "Appeler pour réserver",
    perPerson: "par personne",

    // Events page
    whatsOn: "Événements dans les Pouilles",
    verifiedEvents: "Événements, festivals et expériences vérifiés à proximité",
    allEvents: "Tous les Événements",
    festivals: "Festivals",
    music: "Musique",
    foodWine: "Gastronomie",
    culture: "Culture",
    markets: "Marchés",
    experiences: "Expériences",
    freeEventsOnly: "Événements gratuits uniquement",
    noEventsFound: "Aucun événement trouvé avec ces filtres.",
    inMonopoli: "À Monopoli",
    kmAway: "km de distance",
    verifiedSource: "Source vérifiée",

    // Upsells page
    enhanceYourStayTitle: "Améliorez Votre Séjour",
    transfersBeachExperiences: "Transferts, clubs de plage, expériences et départ tardif",
    transfers: "Transferts",
    beach: "Plage",
    stay: "Séjour",
    bookNow: "Réserver",
    requestBooking: "Demander une Réservation",
    bookingRequested: "Réservation Demandée!",
    bookingReference: "Votre référence est",
    confirmationSoon: "Nous confirmerons votre réservation par email. Notre hôte vous contactera si nécessaire.",
    done: "Terminé",
    yourName: "Votre Nom",
    email: "Email",
    phone: "Téléphone",
    optional: "optionnel",
    preferredDate: "Date Préférée",
    time: "Heure",
    numberOfGuests: "Nombre de Personnes",
    guest: "personne",
    guests: "personnes",
    specialRequests: "Demandes Spéciales",
    anySpecialRequirements: "Exigences ou questions particulières...",
    submitting: "Envoi en cours...",
    confirmAvailability: "Nous confirmerons la disponibilité et vous enverrons les détails par email.",

    // Emergency page
    emergencySupport: "Urgence et Support",
    fastAccess: "Accès rapide aux numéros d'urgence, support propriété et aide urgente",
    propertySupport: "Support Propriété",
    keyIssues: "Pour les problèmes de clés, arrivée tardive, accès à la maison ou questions urgentes à",
    otherUsefulNumbers: "Autres numéros utiles",
    goodToKnow: "Bon à savoir",
    emergency112: "Le 112 fonctionne depuis n'importe quel téléphone, même sans carte SIM",
    pharmacyTip: "Les pharmacies affichent une croix verte et assurent des gardes de nuit — cherchez \"farmacia di turno\"",
    guardiaMedica: "Pour les non-urgences, la Guardia Medica assure les soins médicaux en dehors des heures d'ouverture",
    keepAddress: "Gardez l'adresse de la propriété à portée de main — les services d'urgence pourraient avoir besoin de la localisation exacte",
    call: "Appeler",

    // Concierge page
    yourPugliaConcierge: "Votre Concierge des Pouilles",
    askAbout: "Demandez-moi des plages, restaurants, transferts, événements, ou laissez-moi planifier votre journée parfaite dans les Pouilles.",
    popularRequests: "Demandes populaires",
    whatShouldWeDo: "Que faisons-nous aujourd'hui?",
    askLinaAnything: "Demandez n'importe quoi à Lina...",
    needAirportTransfer: "Besoin d'un transfert aéroport?",
    privateCarFromBari: "Voiture privée depuis Bari",

    // Host pages
    hostDashboard: "Tableau de Bord Hôte",
    signIn: "Se connecter",
    createAccount: "Créer un compte",
    accessDashboard: "Accédez à votre tableau de bord OspitAI",
    registerProperty: "Enregistrez votre propriété avec OspitAI",
    dontHaveAccount: "Pas de compte?",
    alreadyHaveAccount: "Déjà un compte?",
    register: "S'inscrire",
    password: "Mot de passe",
    propertyName: "Nom de la Propriété",
    location: "Localisation",
    pleaseWait: "Veuillez patienter...",
    bySigningIn: "En vous connectant, vous acceptez nos",
    terms: "Conditions",
    and: "et",
    privacyPolicy: "Politique de Confidentialité",

    // Footer
    allRightsReserved: "Tous droits réservés",
    termsConditions: "Conditions Générales",
    unauthorizedUse: "La reproduction ou l'utilisation non autorisée de cette plateforme est interdite.",

    // Common
    loading: "Chargement...",
    error: "Erreur",
    tryAgain: "Réessayer",
    close: "Fermer",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    from: "à partir de",

    // Cultural guidance
    culturalTips: "Conseils Culturels",
    localEtiquette: "Étiquette Locale",
    dressCode: "Code Vestimentaire",
    tippingGuide: "Guide des Pourboires",
    culturalGuidance: "Guide Culturel",
    pugliaCultureTitle: "Culture et Coutumes des Pouilles",
    pugliaCultureDesc: "Conseils essentiels pour respecter les traditions locales",
    
    // Etiquette tips
    greetingsTip: "Salutations: Les Italiens se saluent souvent par un baiser sur les deux joues. Commencez par la gauche.",
    diningTip: "Repas: Le déjeuner est sacré (13h-15h). Beaucoup de magasins ferment. Le dîner commence après 20h.",
    churchTip: "Églises: Couvrez épaules et genoux lors de visites de sites religieux.",
    siestaTip: "Sieste: Respectez le riposo (repos) de 13h à 16h. Beaucoup de commerces ferment.",
    
    // Dress code tips
    beachDressCode: "La tenue de plage est réservée à la plage. Couvrez-vous en visitant les villes.",
    restaurantDressCode: "Tenue décontractée chic pour les restaurants. Pas de shorts dans les établissements haut de gamme.",
    eveningDressCode: "Les Pouillais s'habillent élégamment pour la passeggiata (promenade) du soir.",
    
    // Tipping tips
    tippingRestaurants: "Restaurants: Le service (coperto) est généralement inclus. Arrondissez si satisfait.",
    tippingBars: "Bars: Le pourboire n'est pas attendu mais €0,50-1 pour le service à table est apprécié.",
    tippingTours: "Visites: €5-10 par personne pour d'excellents guides.",
    tippingTaxi: "Taxi: Arrondissez à l'euro supérieur.",
  },

  de: {
    // Home page
    yourPugliaconcierge: "IHR APULIEN CONCIERGE",
    welcomeTo: "Willkommen bei",
    planMyStay: "Meinen Aufenthalt mit Lina planen",
    orTryAsking: "Oder versuchen Sie zu fragen...",
    yourStayPlanned: "Ihr Aufenthalt, geplant für heute",
    personalizedFor: "Personalisierte Vorschläge für",
    quickActions: "Schnelle Aktionen",
    enhanceYourStay: "Verbessern Sie Ihren Aufenthalt",
    makeEffortless: "Machen Sie Ihr Apulien-Erlebnis mühelos",
    viewAll: "Alle anzeigen",
    exploreOspitai: "OspitAI erkunden",
    everythingYouNeed: "Alles was Sie für Ihren Aufenthalt brauchen",
    needHelpNow: "Brauchen Sie jetzt Hilfe?",
    reachHost: "Kontaktieren Sie Ihren Gastgeber für dringende Angelegenheiten",
    messageWhatsapp: "Nachricht auf WhatsApp",
    callProperty: "Unterkunft anrufen",
    emergency: "Notfall",
    arrive: "Ankunft",
    depart: "Abreise",
    checkIn: "Check-in",
    checkOut: "Check-out",
    select: "Auswählen",

    // Navigation
    home: "Startseite",
    concierge: "Concierge",
    beaches: "Strände",
    parking: "Parken",
    events: "Veranstaltungen",
    upsells: "Extras",
    restaurants: "Restaurants",
    hostLogin: "Gastgeber-Login",

    // Beaches page
    beachesTitle: "Strände und Lidos in Apulien",
    verifiedBeaches: "verifizierte Strände von Monopoli bis Salento",
    allBeaches: "Alle Strände",
    quietSpots: "Ruhige Plätze",
    beachClubs: "Strandclubs",
    freeBeaches: "Freie Strände",
    allTowns: "Alle Städte",
    allTypes: "Alle Typen",
    sandy: "Sandig",
    rocky: "Felsig",
    pebble: "Kiesel",
    mixed: "Gemischt",
    beachesFound: "Strände gefunden",
    beachFound: "Strand gefunden",
    localTip: "Lokaler Tipp",
    amenities: "Ausstattung",
    reserveSunbeds: "Liegen reservieren",
    perDay: "pro Tag",
    visitWebsite: "Website besuchen",
    notSureWhichBeach: "Nicht sicher, welcher Strand?",
    askLinaBeach: "Fragen Sie Lina nach einer personalisierten Empfehlung basierend auf Ihren Vorlieben",
    askLina: "Lina fragen",
    viewOnMap: "Auf Karte anzeigen",
    showMap: "Karte anzeigen",
    hideMap: "Karte ausblenden",
    kmFromMonopoli: "km von Monopoli",
    quiet: "Ruhig",
    moderate: "Mäßig",
    popular: "Beliebt",
    veryBusy: "Sehr belebt",
    hiddenGem: "Geheimtipp",
    familyFriendly: "Familienfreundlich",

    // Parking page
    parkingGuide: "Parkplatzführer",
    parkingSpotsAcross: "Parkplätze in Monopoli, Polignano, Ostuni und Bari",
    all: "Alle",
    free: "Kostenlos",
    paid: "Kostenpflichtig",
    walkToCentro: "zu Fuß zum Zentrum",

    // Restaurants page
    whereToEat: "Wo Essen",
    verifiedRestaurants: "Verifizierte Trattorien, Restaurants und Gourmetküche in Apulien",
    allPrices: "Alle Preise",
    budget: "Günstig",
    mid: "Mittel",
    fine: "Gehoben",
    luxury: "Luxus",
    romantic: "Romantisch",
    outdoorSeating: "Außenbereich",
    bookTable: "Tisch reservieren",
    callToReserve: "Anrufen zum Reservieren",
    perPerson: "pro Person",

    // Events page
    whatsOn: "Veranstaltungen in Apulien",
    verifiedEvents: "Verifizierte Veranstaltungen, Festivals und Erlebnisse in der Nähe",
    allEvents: "Alle Veranstaltungen",
    festivals: "Festivals",
    music: "Musik",
    foodWine: "Essen & Wein",
    culture: "Kultur",
    markets: "Märkte",
    experiences: "Erlebnisse",
    freeEventsOnly: "Nur kostenlose Veranstaltungen",
    noEventsFound: "Keine Veranstaltungen mit diesen Filtern gefunden.",
    inMonopoli: "In Monopoli",
    kmAway: "km entfernt",
    verifiedSource: "Verifizierte Quelle",

    // Upsells page
    enhanceYourStayTitle: "Verbessern Sie Ihren Aufenthalt",
    transfersBeachExperiences: "Transfers, Strandclubs, Erlebnisse und spätes Auschecken",
    transfers: "Transfers",
    beach: "Strand",
    stay: "Aufenthalt",
    bookNow: "Jetzt buchen",
    requestBooking: "Buchung anfragen",
    bookingRequested: "Buchung angefragt!",
    bookingReference: "Ihre Referenznummer ist",
    confirmationSoon: "Wir werden Ihre Reservierung in Kürze per E-Mail bestätigen. Unser Gastgeber wird sich bei Bedarf bei Ihnen melden.",
    done: "Fertig",
    yourName: "Ihr Name",
    email: "E-Mail",
    phone: "Telefon",
    optional: "optional",
    preferredDate: "Bevorzugtes Datum",
    time: "Uhrzeit",
    numberOfGuests: "Anzahl der Gäste",
    guest: "Gast",
    guests: "Gäste",
    specialRequests: "Besondere Wünsche",
    anySpecialRequirements: "Besondere Anforderungen oder Fragen...",
    submitting: "Wird gesendet...",
    confirmAvailability: "Wir werden die Verfügbarkeit bestätigen und Ihnen die Details per E-Mail senden.",

    // Emergency page
    emergencySupport: "Notfall und Support",
    fastAccess: "Schneller Zugang zu Notrufnummern, Unterkunft-Support und dringender Hilfe",
    propertySupport: "Unterkunft-Support",
    keyIssues: "Für Schlüsselprobleme, späte Ankunft, Hauszugang oder dringende Angelegenheiten bei",
    otherUsefulNumbers: "Weitere nützliche Nummern",
    goodToKnow: "Gut zu wissen",
    emergency112: "Die 112 funktioniert von jedem Telefon, auch ohne SIM-Karte",
    pharmacyTip: "Apotheken zeigen ein grünes Kreuz und haben Nachtdienst — suchen Sie nach \"farmacia di turno\"",
    guardiaMedica: "Für Nicht-Notfälle bietet die Guardia Medica ärztliche Versorgung außerhalb der Öffnungszeiten",
    keepAddress: "Halten Sie die Adresse der Unterkunft bereit — Rettungsdienste benötigen möglicherweise den genauen Standort",
    call: "Anrufen",

    // Concierge page
    yourPugliaConcierge: "Ihr Apulien Concierge",
    askAbout: "Fragen Sie mich nach Stränden, Restaurants, Transfers, Veranstaltungen, oder lassen Sie mich Ihren perfekten Tag in Apulien planen.",
    popularRequests: "Beliebte Anfragen",
    whatShouldWeDo: "Was machen wir heute?",
    askLinaAnything: "Fragen Sie Lina alles...",
    needAirportTransfer: "Brauchen Sie einen Flughafentransfer?",
    privateCarFromBari: "Privatwagen von Bari",

    // Host pages
    hostDashboard: "Gastgeber-Dashboard",
    signIn: "Anmelden",
    createAccount: "Konto erstellen",
    accessDashboard: "Greifen Sie auf Ihr OspitAI-Dashboard zu",
    registerProperty: "Registrieren Sie Ihre Unterkunft bei OspitAI",
    dontHaveAccount: "Noch kein Konto?",
    alreadyHaveAccount: "Bereits ein Konto?",
    register: "Registrieren",
    password: "Passwort",
    propertyName: "Name der Unterkunft",
    location: "Standort",
    pleaseWait: "Bitte warten...",
    bySigningIn: "Mit der Anmeldung akzeptieren Sie unsere",
    terms: "AGB",
    and: "und",
    privacyPolicy: "Datenschutzrichtlinie",

    // Footer
    allRightsReserved: "Alle Rechte vorbehalten",
    termsConditions: "Allgemeine Geschäftsbedingungen",
    unauthorizedUse: "Die unbefugte Vervielfältigung oder Nutzung dieser Plattform ist untersagt.",

    // Common
    loading: "Wird geladen...",
    error: "Fehler",
    tryAgain: "Erneut versuchen",
    close: "Schließen",
    save: "Speichern",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    back: "Zurück",
    next: "Weiter",
    from: "ab",

    // Cultural guidance
    culturalTips: "Kulturelle Tipps",
    localEtiquette: "Lokale Etikette",
    dressCode: "Kleiderordnung",
    tippingGuide: "Trinkgeld-Guide",
    culturalGuidance: "Kultureller Leitfaden",
    pugliaCultureTitle: "Apulische Kultur und Bräuche",
    pugliaCultureDesc: "Wichtige Tipps zur Wahrung lokaler Traditionen",
    
    // Etiquette tips
    greetingsTip: "Begrüßung: Italiener begrüßen sich oft mit einem Kuss auf beide Wangen. Beginnen Sie links.",
    diningTip: "Essen: Das Mittagessen ist heilig (13-15 Uhr). Viele Geschäfte schließen. Abendessen beginnt nach 20 Uhr.",
    churchTip: "Kirchen: Bedecken Sie Schultern und Knie beim Besuch religiöser Stätten.",
    siestaTip: "Siesta: Respektieren Sie die Ruhezeit (Riposo) von 13-16 Uhr. Viele Geschäfte schließen.",
    
    // Dress code tips
    beachDressCode: "Strandkleidung ist nur für den Strand. Bedecken Sie sich beim Stadtbesuch.",
    restaurantDressCode: "Smart casual für Restaurants. Keine Shorts in gehobenen Lokalen.",
    eveningDressCode: "Apulier kleiden sich elegant für die abendliche Passeggiata (Spaziergang).",
    
    // Tipping tips
    tippingRestaurants: "Restaurants: Servicegebühr (Coperto) ist meist enthalten. Bei Zufriedenheit aufrunden.",
    tippingBars: "Bars: Trinkgeld ist nicht erwartet, aber €0,50-1 für Tischservice wird geschätzt.",
    tippingTours: "Touren: €5-10 pro Person für ausgezeichnete Guides.",
    tippingTaxi: "Taxi: Auf den nächsten Euro aufrunden.",
  },

  es: {
    // Home page
    yourPugliaconcierge: "TU CONCIERGE EN PUGLIA",
    welcomeTo: "Bienvenido a",
    planMyStay: "Planificar mi estancia con Lina",
    orTryAsking: "O intenta preguntar...",
    yourStayPlanned: "Tu estancia, planificada para hoy",
    personalizedFor: "Sugerencias personalizadas para",
    quickActions: "Acciones rápidas",
    enhanceYourStay: "Mejora tu estancia",
    makeEffortless: "Haz tu experiencia en Puglia sin esfuerzo",
    viewAll: "Ver todo",
    exploreOspitai: "Explorar OspitAI",
    everythingYouNeed: "Todo lo que necesitas para tu estancia en Puglia",
    needHelpNow: "¿Necesitas ayuda ahora?",
    reachHost: "Contacta a tu anfitrión para asuntos urgentes o soporte de la propiedad",
    messageWhatsapp: "Mensaje por WhatsApp",
    callProperty: "Llamar a la propiedad",
    emergency: "Emergencia",
    arrive: "Llegada",
    depart: "Salida",
    checkIn: "Check-in",
    checkOut: "Check-out",
    select: "Seleccionar",

    // Navigation
    home: "Inicio",
    concierge: "Concierge",
    beaches: "Playas",
    parking: "Aparcamiento",
    events: "Eventos",
    upsells: "Extras",
    restaurants: "Restaurantes",
    hostLogin: "Acceso Anfitrión",

    // Beaches page
    beachesTitle: "Playas y Lidos en Puglia",
    verifiedBeaches: "playas verificadas de Monopoli a Salento",
    allBeaches: "Todas las playas",
    quietSpots: "Zonas tranquilas",
    beachClubs: "Clubes de playa",
    freeBeaches: "Playas gratuitas",
    allTowns: "Todas las ciudades",
    allTypes: "Todos los tipos",
    sandy: "Arena",
    rocky: "Rocosa",
    pebble: "Guijarros",
    mixed: "Mixta",
    beachesFound: "playas encontradas",
    beachFound: "playa encontrada",
    localTip: "Consejo local",
    amenities: "Servicios",
    reserveSunbeds: "Reservar tumbonas",
    perDay: "por día",
    visitWebsite: "Visitar web",
    notSureWhichBeach: "¿No sabes qué playa elegir?",
    askLinaBeach: "Pregunta a Lina por una recomendación personalizada según tus preferencias",
    askLina: "Preguntar a Lina",
    viewOnMap: "Ver en el mapa",
    showMap: "Mostrar mapa",
    hideMap: "Ocultar mapa",
    kmFromMonopoli: "km de Monopoli",
    quiet: "Tranquila",
    moderate: "Moderada",
    popular: "Popular",
    veryBusy: "Muy concurrida",
    hiddenGem: "Joya oculta",
    familyFriendly: "Familiar",

    // Parking page
    parkingGuide: "Guía de Aparcamiento",
    parkingSpotsAcross: "plazas de aparcamiento en Monopoli, Polignano, Ostuni y Bari",
    all: "Todos",
    free: "Gratis",
    paid: "De pago",
    walkToCentro: "a pie del centro",

    // Restaurants page
    whereToEat: "Dónde Comer",
    verifiedRestaurants: "Trattorias, restaurantes y alta cocina verificados en Puglia",
    allPrices: "Todos los precios",
    budget: "Económico",
    mid: "Medio",
    fine: "Refinado",
    luxury: "Lujo",
    romantic: "Romántico",
    outdoorSeating: "Terraza",
    bookTable: "Reservar mesa",
    callToReserve: "Llamar para reservar",
    perPerson: "por persona",

    // Events page
    whatsOn: "Eventos en Puglia",
    verifiedEvents: "Eventos, festivales y experiencias verificados cerca",
    allEvents: "Todos los Eventos",
    festivals: "Festivales",
    music: "Música",
    foodWine: "Gastronomía",
    culture: "Cultura",
    markets: "Mercados",
    experiences: "Experiencias",
    freeEventsOnly: "Solo eventos gratis",
    noEventsFound: "No se encontraron eventos con estos filtros.",
    inMonopoli: "En Monopoli",
    kmAway: "km de distancia",
    verifiedSource: "Fuente verificada",

    // Upsells page
    enhanceYourStayTitle: "Mejora Tu Estancia",
    transfersBeachExperiences: "Transfers, clubes de playa, experiencias y salida tardía",
    transfers: "Transfers",
    beach: "Playa",
    stay: "Estancia",
    bookNow: "Reservar ahora",
    requestBooking: "Solicitar Reserva",
    bookingRequested: "¡Reserva Solicitada!",
    bookingReference: "Tu referencia es",
    confirmationSoon: "Confirmaremos tu reserva por email. Nuestro anfitrión se pondrá en contacto si necesita más detalles.",
    done: "Hecho",
    yourName: "Tu Nombre",
    email: "Email",
    phone: "Teléfono",
    optional: "opcional",
    preferredDate: "Fecha Preferida",
    time: "Hora",
    numberOfGuests: "Número de Personas",
    guest: "persona",
    guests: "personas",
    specialRequests: "Solicitudes Especiales",
    anySpecialRequirements: "Requisitos especiales o preguntas...",
    submitting: "Enviando...",
    confirmAvailability: "Confirmaremos la disponibilidad y te enviaremos los detalles por email.",

    // Emergency page
    emergencySupport: "Emergencia y Soporte",
    fastAccess: "Acceso rápido a números de emergencia, soporte de propiedad y ayuda urgente",
    propertySupport: "Soporte de Propiedad",
    keyIssues: "Para problemas con llaves, llegada tardía, acceso a la casa o asuntos urgentes en",
    otherUsefulNumbers: "Otros números útiles",
    goodToKnow: "Bueno saber",
    emergency112: "El 112 funciona desde cualquier teléfono, incluso sin tarjeta SIM",
    pharmacyTip: "Las farmacias muestran una cruz verde y hacen turnos nocturnos — busca \"farmacia di turno\"",
    guardiaMedica: "Para no-emergencias, la Guardia Medica proporciona atención médica fuera de horario",
    keepAddress: "Ten la dirección de la propiedad a mano — los servicios de emergencia pueden necesitar la ubicación exacta",
    call: "Llamar",

    // Concierge page
    yourPugliaConcierge: "Tu Concierge de Puglia",
    askAbout: "Pregúntame sobre playas, restaurantes, transfers, eventos, o déjame planificar tu día perfecto en Puglia.",
    popularRequests: "Solicitudes populares",
    whatShouldWeDo: "¿Qué hacemos hoy?",
    askLinaAnything: "Pregunta lo que quieras a Lina...",
    needAirportTransfer: "¿Necesitas transfer al aeropuerto?",
    privateCarFromBari: "Coche privado desde Bari",

    // Host pages
    hostDashboard: "Panel de Anfitrión",
    signIn: "Iniciar sesión",
    createAccount: "Crear cuenta",
    accessDashboard: "Accede a tu panel de OspitAI",
    registerProperty: "Registra tu propiedad con OspitAI",
    dontHaveAccount: "¿No tienes cuenta?",
    alreadyHaveAccount: "¿Ya tienes cuenta?",
    register: "Registrarse",
    password: "Contraseña",
    propertyName: "Nombre de la Propiedad",
    location: "Ubicación",
    pleaseWait: "Por favor espera...",
    bySigningIn: "Al iniciar sesión, aceptas nuestros",
    terms: "Términos",
    and: "y",
    privacyPolicy: "Política de Privacidad",

    // Footer
    allRightsReserved: "Todos los derechos reservados",
    termsConditions: "Términos y Condiciones",
    unauthorizedUse: "Está prohibida la reproducción o uso no autorizado de esta plataforma.",

    // Common
    loading: "Cargando...",
    error: "Error",
    tryAgain: "Reintentar",
    close: "Cerrar",
    save: "Guardar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    from: "desde",

    // Cultural guidance (new)
    culturalTips: "Consejos Culturales",
    localEtiquette: "Etiqueta Local",
    dressCode: "Código de Vestimenta",
    tippingGuide: "Guía de Propinas",
  }
};
